import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import styled from 'styled-components';
import { withMsal } from "@azure/msal-react";
import { withRouter, Redirect } from 'react-router-dom';
import config from '../../env';
import { VBox } from "../../components/Box";
import { Card } from "../../components/Card";
import { PageButtons } from "../../components/Controls/PageButtons";
import { BaseComponent } from "../../components/BaseComponent";
import { Button } from "../../components/Buttons";
import { SET_AZURE_API_KEY } from "../Api/constants";
import { Loader } from "../../components/Loader";
import { selectIsLoggedIn } from "../Api/selectors";

const Container = styled.div`
  .controls {
    text-align: center;
    margin: 24px 0;
  }
`;

const baseState = {
  email: config.default_login || '',
  password: config.default_pass || '',
  reset_email: '',
  error: null,
  loading: false,
  rememberMe: false,
};

/* eslint-disable react/prefer-stateless-function */
class LoginComp extends BaseComponent {
  constructor(props) {
    super(props, { ...baseState });
  }

  onClickLogin() {
    this.props.msalContext.instance.loginRedirect();
  }

  render() {
    if (!this.props.isLoggedIn) {
      this.onClickLogin();
    }

    if (this.props.loading) {
      return <Loader onCard />;
    }

    if (this.props.isLoggedIn) {
      return <Redirect to="/" />;
    }

    return (
      <Container>
        <form>
          <VBox center>
            <Card>
              <h1>{this.lbl('login.title')}</h1>
              <PageButtons>
                <Button isPrimary onClick={this.onClickLogin.bind(this)}>
                  {this.lbl('login.button')}
                </Button>
              </PageButtons>
            </Card>
          </VBox>
        </form>
      </Container>
    );
  }
}

LoginComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    isLoggedIn: selectIsLoggedIn(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setApiKey(data) {
      dispatch({
        type: SET_AZURE_API_KEY,
        data,
      })
    }
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const AzureLogin = compose(
  withRouter,
  withConnect,
  withMsal,
)(LoginComp);
